import { Button, Form, InputNumber, Modal, Radio, message } from '@maxtropy/components';
import { apiV2EnergyReportMonthCycleSavePost } from '@maxtropy/device-customer-apis-v2';
import React, { useEffect, useState } from 'react';

export interface MonthCycleModalProps {
  open: boolean;
  deptAreaId?: number;
  deptOrArea?: number; // 1=部门, 2=区域
  monthCycleType?: number; // 月周期类型：1=自然月，2=自定义
  monthCycleFrom?: number; // 月周期起始日
  monthCycleTo?: number; // 月周期结束日
  onSaveSuccess?: (type: number, fromDay: number, toDay: number) => void;
  onCancel: () => void;
}

const MonthCycleModal: React.FC<MonthCycleModalProps> = ({
  open,
  deptAreaId,
  deptOrArea,
  monthCycleType,
  monthCycleFrom,
  monthCycleTo,
  onSaveSuccess,
  onCancel,
}) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  // 打开弹窗时设置表单值（使用主页面传入的参数）
  useEffect(() => {
    if (open) {
      form.setFieldsValue({
        type: monthCycleType ?? 1,
        fromDay: monthCycleFrom ?? 26,
        toDay: monthCycleTo ?? 25,
      });
    }
  }, [open, monthCycleType, monthCycleFrom, monthCycleTo, form]);

  const handleOk = () => {
    form.validateFields().then(values => {
      const { type, fromDay, toDay } = values;
      setLoading(true);
      apiV2EnergyReportMonthCycleSavePost({
        deptAreaId,
        deptOrArea,
        type,
        fromDay: type === 2 ? fromDay : undefined,
        toDay: type === 2 ? toDay : undefined,
      })
        .then(() => {
          message.success('保存成功');
          onSaveSuccess?.(type, fromDay, toDay);
          onCancel();
        })
        .catch(() => {
          message.error('保存失败');
        })
        .finally(() => setLoading(false));
    });
  };

  return (
    <Modal
      title="月周期设置"
      open={open}
      onCancel={onCancel}
      confirmLoading={loading}
      onOk={handleOk}
      contentClassName="modal-form-content"
    >
      <Form form={form} layout="horizontal" style={{ marginTop: 16 }}>
        <Form.Item label="月周期设置" name="type" initialValue={1} rules={[{ required: true, message: '请选择' }]}>
          <Radio.Group>
            <Radio value={1}>自然月</Radio>
            <Radio value={2}>自定义</Radio>
          </Radio.Group>
        </Form.Item>
        <Form.Item noStyle shouldUpdate={(prev, curr) => prev.type !== curr.type}>
          {({ getFieldValue }) =>
            getFieldValue('type') === 2 && (
              <Form.Item label="本月统计周期" required>
                <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                  <span>上月</span>
                  <Form.Item
                    name="fromDay"
                    initialValue={26}
                    rules={[{ required: true, message: '请输入' }]}
                    style={{ marginBottom: 0 }}
                  >
                    <InputNumber min={1} max={31} style={{ width: 80 }} />
                  </Form.Item>
                  <span>日至本月</span>
                  <Form.Item
                    name="toDay"
                    initialValue={25}
                    rules={[{ required: true, message: '请输入' }]}
                    style={{ marginBottom: 0 }}
                  >
                    <InputNumber min={1} max={31} style={{ width: 80 }} />
                  </Form.Item>
                  <span>日</span>
                </div>
              </Form.Item>
            )
          }
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default MonthCycleModal;
